export default __webpack_public_path__ + "static/media/logo-coinbase.97dccf42.svg";